import styled from "styled-components";

import { Modal } from "components/Modal";

export const WelcomeModalContainer = styled(Modal)`
  .modal-dialog {
    z-index: 100;
  }

  .modal-body {
    margin-top: 30px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    svg {
      margin-bottom: 22px;
    }

    h2 {
      font-size: 25px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    p {
      width: 90%;
      font-size: 14px;
      margin-bottom: 22px;
    }

    button {
      width: 90%;
      font-size: 14px;
      font-weight: 500;
      height: 36px;
    }
  }
`;
